import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import BgImg from "../../assets/portfolio/bg2.png";
import ServiceSide from "./ServiceSide";
import CRMHERO from "../../assets/service/crm-erp-hero.png";
import CRM from "../../assets/service/crm-erp.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChartLine,
  faUsers,
  faWarehouse,
  faBuilding,
  faHandshake,
  faDatabase,
} from "@fortawesome/free-solid-svg-icons";
import OurClients from "../OurClients/OurClients";
import { Helmet } from "react-helmet-async";
const CRMSCMAndERPServices = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true }); // Initialize AOS with animation duration and animation trigger once
  }, []);

  const pillars = [
    {
      icon: faUsers,
      title: "Customer Relationship Management (CRM)",
      description:
        "Enhance customer interactions, improve sales, and boost client retention with efficient CRM tools.",
      bgColor: "bg-green-100",
    },
    {
      icon: faWarehouse,
      title: "Supply Chain Management (SCM)",
      description:
        "Optimize the flow of goods, manage logistics, and ensure smooth inventory control with advanced SCM solutions.",
      bgColor: "bg-blue-100",
    },
    {
      icon: faBuilding,
      title: "Enterprise Resource Planning (ERP)",
      description:
        "Centralize business operations, streamline processes, and achieve real-time insights across all departments.",
      bgColor: "bg-purple-100",
    },
    {
      icon: faChartLine,
      title: "Business Analytics & Insights",
      description:
        "Drive data-driven decisions with comprehensive analytics and performance metrics for strategic growth.",
      bgColor: "bg-orange-100",
    },
  ];

  const benefits = [
    {
      icon: faUsers, // Icon for Customer Service
      title: "Improved Customer Service (CRM)",
      description:
        "Easily manage customer information, history, and interactions to enhance service quality.",
    },
    {
      icon: faChartLine, // Icon for Sales Performance
      title: "Boosted Sales Performance (CRM)",
      description:
        "Streamlined sales processes, automated workflows, and real-time sales insights help drive growth.",
    },
    {
      icon: faHandshake, // Icon for Enhanced Customer Retention
      title: "Enhanced Customer Retention (CRM)",
      description:
        "Proactive engagement and better understanding of customer needs increase loyalty.",
    },
    {
      icon: faDatabase, // Icon for Data-Driven Insights
      title: "Data-Driven Insights (CRM)",
      description:
        "Gain insights into customer behaviors and trends to make informed business decisions.",
    },
  ];

  return (
    <>
      {/* seo data is here */}
      <Helmet>
        <title>CRM, SCM & ERP Services | Deetya Soft</title>
        <meta
          name="description"
          content="Boost business efficiency with Deetya Soft’s CRM, SCM, and ERP solutions for smarter operations and growth."
        />
        <meta
          name="keywords"
          content="CRM software, ERP services, SCM software, Business automation, Enterprise planning, ERP implementation, CRM software solutions for businesses, ERP services provider in India, CRM and ERP integration services, Enterprise resource planning solutions"
        />
        <link
          rel="canonical"
          href="https://deetyasoft.com/crm-scm-and-erp-services"
        />

        {/* <!-- Facebook Meta Tags --> */}
        <meta property="og:locale" content="en_IN" />
        <meta property="og:type" content="article" />
        <meta
          property="og:url"
          content="https://deetyasoft.com/crm-scm-and-erp-services"
        />
        <meta
          property="og:title"
          content="CRM, SCM & ERP Services | Deetya Soft"
        />
        <meta
          property="og:description"
          content="Boost business efficiency with Deetya Soft’s CRM, SCM, and ERP solutions for smarter operations and growth."
        />
        <meta
          property="og:image"
          content="https://deetyasoft.com/static/media/cms.9d71d4d5f844345628a7.png"
        />
        <meta property="og:site_name" content="deetyasoft.com" />
        <meta
          property="article:publisher"
          content="https://www.facebook.com/deetyasoftprivatelimited"
        />

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:url"
          content="https://deetyasoft.com/crm-scm-and-erp-services"
        />
        <meta
          name="twitter:title"
          content="CRM, SCM & ERP Services | Deetya Soft"
        />
        <meta
          name="twitter:description"
          content="Boost business efficiency with Deetya Soft’s CRM, SCM, and ERP solutions for smarter operations and growth."
        />
        <meta
          name="twitter:image"
          content="https://deetyasoft.com/static/media/crm-erp.72373f783655f51b2938.png"
        />
        <meta name="twitter:site" content="@DeetyaSoft" />
        <meta name="twitter:creator" content="@DeetyaSoft" />

        <meta name="yandex-verification" content="31c730ea93a5a9cd" />
        <meta name="copyright" content="Deetyasoft" />
        <meta name="author" content="Deetyasoft" />
        <meta name="email" content="info@deetyasoft.com" />
        <meta name="Distribution" content="Global" />
        <meta name="rating" content="general" />
        <meta name="robots" content="index, follow" />
        <meta name="googlebot" content="index, follow" />
        <meta property="bingbot" content="index, follow " />
        <meta name="Yahoobot" content="index, follow" />
        <meta name="MSNbot" content="index, follow" />
        <meta name="googlebot-news" content="index, follow" />
        <meta name="audience" content="all" />
        <meta name="geo.placename" content="Noida, Uttar Pradesh, India" />
        <meta name="geo.region" content="IN-UP" />
        <meta name="geo.position" content="28.644800;77.373300" />
        <meta name="ICBM" content="28.644800, 77.373300" />
        <link rel="alternate" href="https://deetyasoft.com" hreflang="en-us" />
        <meta http-equiv="content-language" content="en-us" />
        <meta name="msvalidate.01" content="305155CCD42FD63B0A29555BBEE7CA03" />

        {/* <!-- Id+json scripts --> */}
        <>
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                "@context": "http://schema.org",
                "@type": "Organization",
                name: "Deetya Soft Pvt Ltd",
                description:
                  "Boost business efficiency with Deetya Soft’s CRM, SCM, and ERP solutions for smarter operations and growth.",
                image:
                  "https://deetyasoft.com/static/media/crm-erp.72373f783655f51b2938.png",
                logo: "https://www.deetyasoft.com/images/logo.png",
                url: "https://www.deetyasoft.com",
                telephone: ["+91-9015350505", "+91-9717055088"],
                email: "info@deetyasoft.com",
                sameAs: [
                  "https://www.linkedin.com/company/deetya-soft-private-limited",
                  "https://www.facebook.com/deetyasoftprivatelimited",
                  "https://www.instagram.com/deetyasoft",
                  "https://www.youtube.com/@deetyasoft",
                  "https://www.crunchbase.com/organization/deetyasoft",
                ],
                address: {
                  "@type": "PostalAddress",
                  streetAddress:
                    "FF‑06, First Floor, Mahaluxmi Square, Plot No. C‑1, Abhay Khand II, Indirapuram",
                  addressLocality: "Ghaziabad",
                  addressRegion: "Uttar Pradesh",
                  postalCode: "201014",
                  addressCountry: "IN",
                },
              }),
            }}
          />
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                "@context": "http://schema.org",
                "@type": "Organization",
                url: "https://www.deetyasoft.com",
                contactPoint: [
                  {
                    "@type": "ContactPoint",
                    telephone: "+91-981-862-7588",
                    contactType: "technical support",
                    areaServed: "IN",
                  },
                  {
                    "@type": "ContactPoint",
                    telephone: "+91-901-535-0505",
                    contactType: "sales",
                    areaServed: "IN",
                  },
                ],
              }),
            }}
          />
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                "@context": "http://schema.org",
                "@type": "Review",
                author: {
                  "@type": "Person",
                  name: "Parshan ",
                },
                reviewBody:
                  "Deetya Soft helps companies to enable effective business operations through custom web solutions, IVR, and cloud telephony services.",
                url: "https://www.deetyasoft.com/",
                description:
                  "Deetya Soft Pvt Ltd offers services such as IVR systems, virtual phone numbers, toll-free numbers, call tracking, enquiry management, LMS, web solutions, VOIP, and cloud-based communication solutions.",
                datePublished: "2025-06-17",
                name: "Deetya Soft Pvt Ltd",
                reviewRating: {
                  "@type": "Rating",
                  worstRating: "1",
                  ratingValue: "5",
                  bestRating: "5",
                },
                itemReviewed: {
                  "@type": "Organization",
                  name: "Deetya Soft Pvt Ltd",
                },
              }),
            }}
          />
        </>
      </Helmet>

      <div className="relative bg-[#2f68a2] overflow-hidden pb-5 text-white">
        {/* Content */}
        <div className="relative z-20 max-w-7xl mx-auto  px-6 md:py-20 py-10 grid md:grid-cols-2 lg:gap-20 md:gap-10  items-start">
          {/* Left Side */}
          <div>
            <h1 className="text-3xl md:text-4xl font-bold leading-snug mb-4">
              CRM SCM & ERP Service
            </h1>
            <p className="text-white/90 mb-6 text:base md:text-lg">
              Empower your business with robust CRM (Customer Relationship
              Management), SCM (Supply Chain Management), and ERP (Enterprise
              Resource Planning) solutions. We provide end-to-end development
              and integration, ensuring seamless operations, enhanced
              productivity, and data-driven decision-making
            </p>
            <button
              className="bg-orange-500   hidden md:block hover:bg-orange-600 text-white px-5 py-3 rounded shadow-md transition"
              onClick={() => {
                const target = document.getElementById("bottomTarget");
                if (target) {
                  target.scrollIntoView({ behavior: "smooth", block: "start" });
                  // Optional offset tweak using window.scrollBy
                  setTimeout(() => {
                    window.scrollBy(0, -100); // scrolls 100px up after reaching the section
                  }, 600);
                }
              }}
            >
              Let's Get Started
            </button>
          </div>

          {/* Right Side Image */}
          <div className="flex justify-center">
            <img
              src={CRMHERO}
              alt="cms-scm"
              className="md:w-[90%] object-contain w-full  max-w-lg animate-float"
            />
          </div>
        </div>

        {/* FIRST CURVE - White */}
        <div className="absolute bottom-0 left-0 w-full z-10">
          <svg
            className="w-full h-auto"
            viewBox="0 0 1440 290"
            preserveAspectRatio="none"
          >
            <path
              fill="#ffffff"
              fillOpacity="1"
              d="M0,160L60,165.3C120,171,240,181,360,165.3C480,149,600,107,720,117.3C840,128,960,192,1080,208C1200,224,1320,192,1380,176L1440,160L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
            />
          </svg>
        </div>

        {/* SECOND CURVE - Light Blue */}
        <div className="absolute bottom-[20px] left-0 w-full z-0">
          <svg
            className="w-full h-auto"
            viewBox="0 0 1440 320"
            preserveAspectRatio="none"
          >
            <path
              fill="#a6c7e2" // Light blue like in the image
              fillOpacity="1"
              d="M0,288L60,272C120,256,240,224,360,197.3C480,171,600,149,720,160C840,171,960,213,1080,208C1200,203,1320,149,1380,122.7L1440,96L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
            />
          </svg>
        </div>
      </div>

      {/* Hero section  */}

      {/* second section is here */}

      <div className="">
        <h2 className="text-xl px-2 md:px-0 md:text-3xl font-bold text-center mt-4 mb-2 text-gray-600">
          CRM SCM & ERP Service
        </h2>
        <div className="md:w-40 w-20 h-1 bg-main mx-auto md:mb-3 mb-1 rounded-full" />

        <p className="text-center text-gray-700 px-4 md:px-20 lg:px-40">
          Streamline your stock, reduce costs, and ensure products are always
          available when needed.
        </p>

        {/* Wrapper that allows scrolling */}
        <div className="px-  md:px-5 sm:px-3 grid grid-cols-1 md:grid-cols-1 lg:grid-cols-[2fr_1fr] gap-3 sm:gap-2 md:gap-8">
          {/* Main Content */}
          <div className="container mx-auto px-4 py-8">
            <div className="grid grid-cols-1 md:grid-cols-1 gap-8">
              {/* Image Section */}

              <div className="w-full  max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
                <img
                  src={CRM}
                  alt="CRM-SCM-&-ERP-Service"
                  className="w-full h-full  object-cover"
                />
              </div>

              {/* Text Content Section */}

              <div className="space-y-2 md:text-base text-sm order-1 md:order-2 text-justify">
                <h1 className="md:text-3xl text-xl font-semibold text-main">
                  CRM, SCM, and ERP Services
                </h1>

                <p className="text-gray-600">
                  Empower your business with robust{" "}
                  <span className="font-semibold">
                    CRM (Customer Relationship Management)
                  </span>
                  ,{" "}
                  <span className="font-semibold">
                    SCM (Supply Chain Management)
                  </span>
                  , and{" "}
                  <span className="font-semibold">
                    ERP (Enterprise Resource Planning)
                  </span>{" "}
                  solutions. We provide end-to-end development and integration,
                  ensuring seamless operations, enhanced productivity, and
                  data-driven decision-making.
                </p>

                <h2 className="md:text-3xl text-xl font-semibold text-main">
                  Why Choose Our Services?
                </h2>

                <p className="text-gray-600">
                  Our solutions are designed to optimize business processes,
                  improve efficiency, and drive growth. Whether you are looking
                  to streamline customer interactions, manage your supply chain
                  effectively, or centralize business operations, we have the
                  expertise to make it happen.
                </p>

                <ul className="list-disc list-inside space-y-2 text-gray-600">
                  <li>
                    <strong>Custom CRM Development:</strong> Streamline customer
                    interactions and enhance sales processes.
                  </li>
                  <li>
                    <strong>SCM Solutions:</strong> Optimize your supply chain
                    for efficiency and transparency.
                  </li>
                  <li>
                    <strong>ERP Implementation:</strong> Centralize business
                    operations with scalable ERP solutions.
                  </li>
                  <li>
                    <strong>Web Solutions:</strong> Modern, responsive website
                    design and advanced web technologies.
                  </li>
                </ul>

                <h2 className="text-2xl font-semibold text-main">
                  Our Expertise in CRM, SCM, and ERP Solutions
                </h2>

                <p className="text-gray-600">
                  At <span className="font-bold">Deetya Soft</span>, we
                  specialize in delivering customized CRM, SCM, and ERP
                  platforms that drive business efficiency and growth. With
                  expertise in technologies like{" "}
                  <span className="font-semibold">
                    Salesforce, SAP, Oracle, and Microsoft Dynamics
                  </span>
                  , we ensure seamless integration and scalability to meet your
                  business needs.
                </p>

                <p className="text-gray-600 leading-relaxed">
                  We understand that every business is unique in its size,
                  nature, and objectives. Our approach is tailored to your
                  specific needs. Before starting any project, we analyze your
                  business requirements thoroughly to suggest the best platform
                  for development.
                </p>

                <p className="text-gray-600 text-lg leading-relaxed">
                  Since CRM, SCM, and ERP solutions handle sensitive business
                  data, <span className="font-semibold">security</span> is a top
                  priority. We ensure that data storage and transaction
                  processes are{" "}
                  <span className="font-semibold">
                    user-friendly, secure, and hassle-free
                  </span>
                  , providing you with peace of mind and trust.
                </p>

                <p className="text-gray-600">
                  At <span className="font-bold">Deetya Soft</span>, we not only
                  build business solutions; we build{" "}
                  <span className="font-semibold">trust and efficiency</span>.
                  Let us help you elevate your business processes with powerful,
                  secure, and user-friendly CRM, SCM, and ERP solutions.
                </p>
              </div>
            </div>
          </div>
          {/* Sticky Sidebar */}
          <div className="sticky md:block hidden  top-20 self-start  p-3  h-fit">
            <ServiceSide />
          </div>
        </div>
      </div>

      {/* make it next section */}
      <div
        className="py-5 px-5 relative"
        // data-aos='fade-up'
        style={{
          backgroundImage: `url(${BgImg})`,
          backgroundRepeat: "repeat",
          backgroundSize: "auto",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
          minHeight: "60vh",
        }}
      >
        <div className="text-center py-10 px-4">
          <h2 className="text-3xl md:text-4xl font-extrabold">
            <span className="text-black">CRM, SCM, & ERP</span>
            <span className="text-sky-500"> Feature</span>
          </h2>

          <div className="relative w-fit mx-auto mt-2">
            <div className="h-[1px] bg-gray-400 md:w-[200px] w-[100px] mx-auto"></div>
            <div className="absolute left-1/2 -translate-x-1/2 -top-[1px] flex gap-2">
              <div className="w-8 h-[2px] bg-sky-500"></div>
              <div className="w-8 h-[2px] bg-sky-500"></div>
            </div>
          </div>

          <p className="text-gray-800 text-base mt-4">
            What You Get Using Our Scm Crm & Erp Management System
          </p>
        </div>

        <div className="container mx-auto px-4 pb-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {pillars.map((pillar, index) => (
              <div
                key={index}
                className="bg-gray-50 shadow-md  overflow-hidden hover:shadow-lg transition-shadow duration-300"
              >
                <div className="p-8 text-center">
                  <div
                    className={`w-16 h-16 flex items-center justify-center rounded-full ${pillar.bgColor} mb-4 mx-auto`}
                  >
                    <FontAwesomeIcon
                      icon={pillar.icon}
                      className="text-sky-500 text-2xl"
                    />
                  </div>
                  <h5 className="md:text-lg text-base font-semibold text-gray-800 mb-3">
                    {pillar.title}
                  </h5>
                  <p className="text-gray-600 text-sm">{pillar.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* client section */}
      <div id="bottomTarget" className=" py-10">
        <OurClients />
      </div>
      {/* benifits section is here */}
      <div className="bg-white  py-12">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-8">
            <h2 className="md:text-3xl text-2xl font-semibold text-gray-700">
              Benifits CRM, SCM, & ERP
            </h2>
            <div className="w-40 h-1 bg-main mx-auto mt-2 rounded-full"></div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {benefits.map((benefit, index) => (
              <div
                key={index}
                className="bg-white text-center shadow-md rounded-lg p-6 hover:shadow-lg transition duration-300"
              >
                <div className="text-main  text-4xl mb-4">
                  <FontAwesomeIcon icon={benefit.icon} />
                </div>
                <h5 className="text-lg font-bold mb-2">{benefit.title}</h5>
                <p className="text-gray-600 text-sm">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* <FaqECommerce /> */}
    </>
  );
};

export default CRMSCMAndERPServices;
